export default function fetchWrapper(url, options = {}) {
    return fetch(url, options)
        .then((response) => (response.ok ? Promise.resolve(response.json()) : Promise.reject(response)));
}

export function addressData(type, website, postalCode, houseNumber, options = {}) {
    // eslint-disable-next-line no-undef
    return fetch(`https://api-${type}.keuze.nl/v1/postcode-check/${website}/${postalCode}/${houseNumber}`, options)
        .then((response) => (response.ok ? Promise.resolve(response.json()) : Promise.reject));
}

export function getObjectFromLocalStorage(key) {
    try {
        return JSON.parse(window.localStorage.getItem(key));
    } catch (error) {
        return false;
    }
}
